import { c as _c } from "react/compiler-runtime";
import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchableSelect, SearchableSelectProps } from 'record-it-components/input/SearchableSelect/SearchableSelect';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { ConstructionSiteUtils } from '../../../classes/entities/ConstructionSite/ConstructionSiteUtils';
import { useNullableSelectEntityItems } from '../../../hooks/entity/useNullableSelectEntityItems/useNullableSelectEntityItems';
export type ConstructionSiteSelectProps = PropsWithoutChildren<Omit<SearchableSelectProps<ConstructionSite>, 'label' | 'value' | 'items' | 'onValueChanged' | 'getDisplayTextOfItem' | 'getKeyOfItem'>> & {
  readonly availableConstructionSites: Array<ConstructionSite>;
  readonly constructionSiteId: string | null;
  readonly onConstructionSiteChanged: (value: string | null) => void;
};
export const ConstructionSiteSelect: FunctionComponent<ConstructionSiteSelectProps> = React.memo(props => {
  const $ = _c(27);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let availableConstructionSites;
  let constructionSiteId;
  let onConstructionSiteChanged;
  let remainingProps;
  if ($[2] !== t0) {
    ({
      availableConstructionSites,
      constructionSiteId,
      onConstructionSiteChanged,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = availableConstructionSites;
    $[4] = constructionSiteId;
    $[5] = onConstructionSiteChanged;
    $[6] = remainingProps;
  } else {
    availableConstructionSites = $[3];
    constructionSiteId = $[4];
    onConstructionSiteChanged = $[5];
    remainingProps = $[6];
  }
  const {
    t
  } = useTranslation();
  let t1;
  if ($[7] !== t) {
    t1 = t("components.input.ConstructionSiteSelect.constructionSiteNotFound");
    $[7] = t;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== t) {
    t2 = t("components.input.ConstructionSiteSelect.noConstructionSite");
    $[9] = t;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== availableConstructionSites || $[12] !== constructionSiteId || $[13] !== onConstructionSiteChanged || $[14] !== t1 || $[15] !== t2) {
    t3 = {
      value: constructionSiteId,
      entities: availableConstructionSites,
      entityNotFoundText: t1,
      nullValueText: t2,
      onValueChanged: onConstructionSiteChanged,
      getDisplayTextOfEntity: ConstructionSiteUtils.displayTextGetter,
      getKeyOfEntity: ConstructionSiteUtils.keyGetter,
      getValueOfEntity: _temp
    };
    $[11] = availableConstructionSites;
    $[12] = constructionSiteId;
    $[13] = onConstructionSiteChanged;
    $[14] = t1;
    $[15] = t2;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  const useSelectEntityItemsReturnValue = useNullableSelectEntityItems(t3);
  let t4;
  if ($[17] !== t) {
    t4 = t("components.input.ConstructionSiteSelect.label");
    $[17] = t;
    $[18] = t4;
  } else {
    t4 = $[18];
  }
  let t5;
  if ($[19] !== remainingProps || $[20] !== t4 || $[21] !== useSelectEntityItemsReturnValue.getDisplayTextOfItem || $[22] !== useSelectEntityItemsReturnValue.getKeyOfItem || $[23] !== useSelectEntityItemsReturnValue.items || $[24] !== useSelectEntityItemsReturnValue.onSelectedItemChanged || $[25] !== useSelectEntityItemsReturnValue.selectedItem) {
    t5 = <SearchableSelect label={t4} value={useSelectEntityItemsReturnValue.selectedItem} items={useSelectEntityItemsReturnValue.items} onValueChanged={useSelectEntityItemsReturnValue.onSelectedItemChanged} getDisplayTextOfItem={useSelectEntityItemsReturnValue.getDisplayTextOfItem} getKeyOfItem={useSelectEntityItemsReturnValue.getKeyOfItem} data-testid="ConstructionSiteSelect.SearchableSelect" {...remainingProps} />;
    $[19] = remainingProps;
    $[20] = t4;
    $[21] = useSelectEntityItemsReturnValue.getDisplayTextOfItem;
    $[22] = useSelectEntityItemsReturnValue.getKeyOfItem;
    $[23] = useSelectEntityItemsReturnValue.items;
    $[24] = useSelectEntityItemsReturnValue.onSelectedItemChanged;
    $[25] = useSelectEntityItemsReturnValue.selectedItem;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
});
function _temp(constructionSite) {
  return constructionSite.id;
}